module.exports = new __parcel__URL__("okay_button.33e516f4.png").toString();